import { render, staticRenderFns } from "./list-text-type.vue?vue&type=template&id=03e13ab5&scoped=true&lang=pug&"
import script from "./list-text-type.vue?vue&type=script&lang=ts&"
export * from "./list-text-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e13ab5",
  null
  
)

export default component.exports